<div class="form-grid">
  <div class="form-field form-field--wide">
    <label>Description</label>
    <p-autoComplete
      [formControl]="$any(inputFormGroup?.controls?.['job_description']) || technicalViewService.jobForm.controls['job_description']"
      [suggestions]="suggestedDescriptions"
      (completeMethod)="filterDescriptions($event)"
      (onSelect)="onDescriptionSelect($event)"
      [dropdown]="true"
      [minLength]="1"
      [autoHighlight]="true"
      [forceSelection]="false"
      [multiple]="false"
      [scrollHeight]="'220px'"
      placeholder="Component (type or pick)"
      styleClass="w-full"
      appendTo="body"
    ></p-autoComplete>
  </div>

  <div class="form-field form-field--wide">
    <div class="remarks-label-row">
      <label>Remarks</label>
      <button
        pButton
        type="button"
        icon="pi pi-sparkles"
        label="Draft"
        class="p-button-text p-button-sm remarks-draft-btn"
        [loading]="drafting"
        (click)="draftRemark()"
        pTooltip="Suggest a remark for this component"
        tooltipPosition="left"
      ></button>
    </div>
    <p-autoComplete
      [formControl]="$any(inputFormGroup?.controls?.['remarks'])"
      [suggestions]="suggestedRemarks"
      (completeMethod)="filterRemarks($event)"
      [dropdown]="true"
      [minLength]="0"
      [autoHighlight]="true"
      [forceSelection]="false"
      [multiple]="false"
      [scrollHeight]="'220px'"
      placeholder="Detail (type, or pick for this component)"
      styleClass="w-full"
      appendTo="body"
    ></p-autoComplete>
  </div>
</div>

<div class="dialog-actions job-form-actions" *ngIf="isEdit">
  <button
    pButton
    type="button"
    icon="pi pi-check"
    label="Update Job"
    class="p-button-primary w-full"
    [loading]="loading"
    (click)="updateJob()"
  ></button>
</div>
